export function CategoryButton({ label, color, onClick }) {
  return (
    <button
      onClick={onClick}
      className={`
        snap-start
        inline-flex items-center
        px-5 py-2
        rounded-full
        font-semibold text-white
        ${color}
        flex-shrink-0
        transition
        hover:scale-105
        active:scale-95
      `}
    >
      {label}
    </button>
  );
}
